/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

export const TOPIC_TREE_OBJECT = {
  topicId: PropTypes.string.isRequired,
  topicName: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  subCategory: PropTypes.string,
};

export const TOPIC_INTENT_OBJECT = {
  priority: PropTypes.number.isRequired,
  ref_id: PropTypes.string.isRequired,
  topic_id: PropTypes.number.isRequired,
  topic_name: PropTypes.string.isRequired,
};

export const FAQ_ARTICLE = {
  articleContent: PropTypes.string.isRequired,
  articleId: PropTypes.string.isRequired,
  articleTitle: PropTypes.string.isRequired,
  topicId: PropTypes.string,
  breadCrumbPath: PropTypes.string,
  breadCrumbTitle: PropTypes.string,
};

export const FPTI_DATA = {
  pgrp: PropTypes.string.isRequired,
  page: PropTypes.string.isRequired,
  e: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  event_name: PropTypes.string.isRequired,
};

export const PP_SAC_NUMBER = {
  phone_type: PropTypes.string,
  phone_value: PropTypes.string,
};

export const CUSTOMER_HOUR = {
  hoursOfService: PropTypes.string,
  generalTime1: PropTypes.string,
  generalTime2: PropTypes.string,
  amTime1: PropTypes.string,
  amTime2: PropTypes.string,
  amPerCall: PropTypes.string,
};

export const CALL_US_INFO = {
  logOutPrefferedNumber: PropTypes.string,
  customerHour: PropTypes.shape(CUSTOMER_HOUR),
  prefferedHoo: PropTypes.string,
  isInstructionPresent: PropTypes.bool,
  specialInstruction: PropTypes.string,
  prefferedNumber: PropTypes.string,
  phoneNumbers: PropTypes.arrayOf(PropTypes.string),
  isphonePresent: PropTypes.bool,
  ppSACNumbers: PropTypes.arrayOf(PropTypes.shape(PP_SAC_NUMBER)),
  showServiceHourHeader: PropTypes.bool,
  webPin: PropTypes.string,
  mtsPhone: PropTypes.string,
  generalMTS: PropTypes.string,
  generalPhoneNumber: PropTypes.string,
  amPhone: PropTypes.string,
  amFlag: PropTypes.string,
  accountManagerEmail: PropTypes.string,
};
